// extracted by mini-css-extract-plugin
module.exports = {"dateBlock":"MCDate_dateBlock__3eYd4","dateBlockToday":"MCDate_dateBlockToday__3X4nu","dateBlockSunday":"MCDate_dateBlockSunday__16Uk_"};